import GlobalTypes from '../types/GlobalTypes';

const initialState = {
  isLoading: false,
  statusData: [],
  countryData: [],
  stateData: [],
  addressData: [],
  moduleStatus: [],
  notificationData: []
};

// eslint-disable-next-line default-param-last
const global = (state = initialState, action) => {
  switch (action.type) {
    case GlobalTypes.GET_CLIENT_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GlobalTypes.GET_CLIENT_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        statusData: action.payload
      };
    case GlobalTypes.GET_CLIENT_STATUS_ERROR:
      return {
        ...state,
        isLoading: false,
        statusData: []
      };

    case GlobalTypes.GET_COUNTRY_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GlobalTypes.GET_COUNTRY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        countryData: action.payload
      };
    case GlobalTypes.GET_COUNTRY_ERROR:
      return {
        ...state,
        isLoading: false,
        statusData: []
      };

    case GlobalTypes.GET_STATE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GlobalTypes.GET_STATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        stateData: action.payload
      };
    case GlobalTypes.GET_STATE_ERROR:
      return {
        ...state,
        isLoading: false,
        statusData: []
      };
    case GlobalTypes.GET_ADDRESS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GlobalTypes.GET_ADDRESS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        addressData: action.payload
      };
    case GlobalTypes.GET_ADDRESS_ERROR:
      return {
        ...state,
        isLoading: false,
        addressData: []
      };

    case GlobalTypes.GET_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GlobalTypes.GET_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        moduleStatus: action.payload
      };
    case GlobalTypes.GET_STATUS_ERROR:
      return {
        ...state,
        isLoading: false,
        moduleStatus: []
      };
    case GlobalTypes.GET_ALL_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GlobalTypes.GET_ALL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notificationData: action.payload
      };
    case GlobalTypes.GET_ALL_NOTIFICATIONS_ERROR:
      return {
        ...state,
        isLoading: false,
        notificationData: []
      };
    default:
      return state;
  }
};

export default global;
